import * as React from 'react';

import {Card} from 'shells/card/card';
import {FormField} from 'shells/form/form-field';
import {TwoLine} from 'shells/two-line/two-line';

import type {EditionFragment_audience_fromSavedFilter as SavedFilter} from 'nutshell-graphql-types';

import {getSubscribersElement} from '../prepare-to-send-page/saved-list-selector';

import styles from './send-to-saved-list-field.module.css';

type Props = {
    savedFilter: SavedFilter;
};

export function SendToSavedListField(props: Props) {
    return (
        <FormField innerId='to' label='To'>
            <Card hasBorder={true} backgroundColor='white' fitHeight={true}>
                <div className='py-8 px-16'>
                    <TwoLine
                        topRow={props.savedFilter.name}
                        isLargeWithSmallBottomRow={true}
                        bottomRow={
                            <div className={styles['bottom-row']}>
                                {getSubscribersElement(props.savedFilter)}
                            </div>
                        }
                    />
                </div>
            </Card>
        </FormField>
    );
}
